import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
export function loadScript(src) {
  var s = document.createElement("script");
  s.type = "text/javascript";
  s.src = src;
  document.body.appendChild(s);
  return new Promise(function (res, rej) {
    s.onload = res;
    s.onerror = rej;
  });
}